import React from 'react'
import { Grid, type GridProps } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledContainer = styled(Grid)`
  align-items: center;
  flex-wrap: nowrap;
`

const StyledChipsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& > *': {
    width: 16,
    height: 16,
    margin: 1,
    alignContent: 'center',
    '&:last-child': {
      marginRight: theme.spacing(0.5),
    },
  },
}))

export interface EntityDisplayProps extends GridProps {
  chips?: React.ReactNode
  info?: React.ReactNode
  name: React.ReactNode
}

/**
 * Base component for displaying entity information in a consistent layout:
 * name > chips > info
 */
const EntityDisplay = ({ chips, info, name, ...props }: EntityDisplayProps) => (
  <StyledContainer container {...props}>
    <Grid item>{name}</Grid>
    {chips && (
      <Grid item ml={0.5}>
        <StyledChipsContainer>{chips}</StyledChipsContainer>
      </Grid>
    )}
    {info && (
      <Grid item ml={0.5}>
        {info}
      </Grid>
    )}
  </StyledContainer>
)

export default EntityDisplay
